import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 last:border-0" data-id="element-11">
      <button className="w-full py-4 px-2 flex items-center justify-between text-left focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-12">
        <span className="font-semibold text-gray-900 text-lg" data-id="element-13">{question}</span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-gray-500 flex-shrink-0 ml-4" data-id="element-14" /> : <ChevronDown className="w-5 h-5 text-gray-500 flex-shrink-0 ml-4" data-id="element-15" />}
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-4' : 'max-h-0 opacity-0'}`} data-id="element-16">
        <p className="text-gray-600 px-2 leading-relaxed" data-id="element-17">{answer}</p>
      </div>
    </div>;
}